import baseTheme from '@bottlebooks/gatsby-theme-event/src/theme';
import merge from 'lodash/merge';
import { darken } from 'polished';

const theme = {
  ...baseTheme,

  fonts: merge({}, baseTheme.fonts, {
    heading: 'RockfordSans, sans-serif',
    body: 'RockfordSans, sans-serif',
  }),
  fontWeights: {
    ...baseTheme.fontWeights,
    heading: '700',
    body: '400',
  },
  title: merge({}, baseTheme.title, {
    _base: {
      WebkitFontSmoothing: 'antialiased',
    }, // Add antialiasing to titles.
  }),
  colors: merge({}, baseTheme.colors, {
    ...baseTheme.colors,
    primary: '#21699F',
    secondary: darken(0.1)('#21699F'),
    accent: '#ffbd26',
  }),
  label: {
    ...baseTheme.label,
    _base: { ...baseTheme.label._base, color: '#666' },
  },
  text: {
    ...baseTheme.text,
   
  },
  styles: {
    ...baseTheme.styles,
    root: {
      ...baseTheme.styles.root,
      WebkitFontSmoothing: 'subpixel-antialiased',
    },
  },
};

// console.log(theme);
export default theme;
